var map = {
	"./card1.png": 375,
	"./card10.png": 95,
	"./card11.png": 550,
	"./card12.png": 109,
	"./card13.png": 628,
	"./card14.png": 891,
	"./card15.png": 386,
	"./card16.png": 969,
	"./card2.png": 516,
	"./card3.png": 413,
	"./card4.png": 554,
	"./card5.png": 379,
	"./card6.png": 48,
	"./card7.png": 521,
	"./card8.png": 654,
	"./card9.png": 143,
	"./emptyCard.png": 737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 664;